module.exports = __webpack_public_path__ + "static/media/tti_ready@2x.aa0be583.png";